module.exports = __webpack_public_path__ + "static/media/unconstrainedfund.9a72291a.jpg";